import { mapGetters, mapMutations } from "vuex";

export default {
  computed: {
    ...mapGetters(["user"]),
  },
  methods: {
    ...mapMutations(["addItem", "removeItem"]),
    addBookmark(type, bookmark) {
      this.addItem({ type, bookmark });
    },
    removeBookmark(type, bookmark) {
      this.removeItem({ type, bookmark });
    },
  },
};
